import { render, staticRenderFns } from "./RolesModal.vue?vue&type=template&id=6365c6e4&"
import script from "./RolesModal.vue?vue&type=script&lang=js&"
export * from "./RolesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports